import { createSelector } from 'reselect';
import { MadadRenewDto } from 'utils/entities';
import { mapToTopTenBadgeVariant } from 'components/madad/utils';
import { LoadType } from 'store/sagas/apiService/types';
import { createIsLoadingSelector, madadAgentsOfficesDomainSelector, makeNullSafeDomainGetter, madadSearchAgentsOfficesDomainSelector } from './common';
import { MadadAgencyCard, MadadAgentCard } from 'components/madad/entities';
import { isNil } from 'lodash';


const madadSelector = makeNullSafeDomainGetter(madadAgentsOfficesDomainSelector, LoadType.MadadAgentsOffices);
export const isLoadingMadadSelector = createIsLoadingSelector(madadAgentsOfficesDomainSelector);

const madadSearchSelector = makeNullSafeDomainGetter(madadSearchAgentsOfficesDomainSelector, LoadType.MadadAgentsOffices);
export const isLoadingMadadSearchSelector = createIsLoadingSelector(madadSearchAgentsOfficesDomainSelector);

export const convertAgentDtoToCard = (record: MadadRenewDto): MadadAgentCard => ({
  id: record.agentId,
  docId: record.docId,
  cityDocId: null,
  neighborhoodDocId: null,
  agentName: record.agentName,
  soldCount: record.soldCount,
  exclusiveListingsCount: record.exclusiveListingCount,
  agencyName: record.officeName,
  agencyImageUrl: null,
  agencyId: record.officeId,
  coverImage: record.coverImage,
  avatarImage: record.avatarImage,
  topTenBadgeVariant: mapToTopTenBadgeVariant[record.category],
  phone: record.phone,
  isRegistered: record.isRegistered,
  ...(isNil(record.isLeadingAgent) ? null : { isLeadingAgent: record && record.isLeadingAgent }),
});

export const convertOfficeDtoToCard = (record: MadadRenewDto): MadadAgencyCard => ({
  id: record.officeId,
  docId: record.docId,
  cityDocId: null,
  neighborhoodDocId: null,
  soldCount: record.soldCount,
  exclusiveListingsCount: record.exclusiveListingCount,
  agencyName: record.officeName,
  coverImage: record.coverImage,
  avatarImage: record.avatarImage,
  topTenBadgeVariant: mapToTopTenBadgeVariant[record.category],
  phone: record.phone,
  isRegistered: record.isRegistered,
});

const madadAgentsSelector = createSelector(
  [ madadSelector ],
  (data): MadadRenewDto[] => {
    if (data && data.agent && data.agent.length) {
      return data.agent;
    }
    return [];
  }
);

export const madadAgentsCardsSelector = createSelector(madadAgentsSelector, (agents) => agents.map(convertAgentDtoToCard));

const madadOfficesSelector = createSelector(
  [ madadSelector ],
  (data): MadadRenewDto[] => {
    if (data && data.office && data.office.length) {
      return data.office;
    }
    return [];
  }
);

export const madadOfficesCardsSelector = createSelector(madadOfficesSelector, (offices) => offices.map(convertOfficeDtoToCard));


const madadSearchAgentsSelector = createSelector(
  [ madadSearchSelector ],
  (data): MadadRenewDto[] => {
    if (data && data.agent && data.agent.length) {
      return data.agent;
    }
    return [];
  }
);

export const madadSearchAgentsCardsSelector = createSelector(madadSearchAgentsSelector, (agents) => agents.map(convertAgentDtoToCard));

const madadSearchOfficesSelector = createSelector(
  [ madadSearchSelector ],
  (data): MadadRenewDto[] => {
    if (data && data.office && data.office.length) {
      return data.office;
    }
    return [];
  }
);

export const madadSearchOfficesCardsSelector = createSelector(madadSearchOfficesSelector, (offices) => offices.map(convertOfficeDtoToCard));

